export function indexSettings(settings) {
    let index = {};
    const len = settings.length;
    for (let ss, ii = 0; ii < len; ii++) {
        ss = settings[ii];
        index[ss.setting_key] = ss;
    }
    return index;
}

export function getSettings(defaultSettings, data) {
    const settings = [...defaultSettings];
    const len = settings.length;
    const slLen = data.length;
    let setting, slSetting, sli;
    for (let i = 0; i < len; i++) {
        setting = settings[i];
        for (sli = 0; sli < slLen; sli++) {
            slSetting = data[sli];
            if (
                slSetting.calendar_type === setting.calendar_type &&
                slSetting.setting_key === setting.setting_key &&
                ((setting.field_type === 'color' && setting.can_clear) ||
                    setting.field_type === 'date' ||
                    slSetting.setting_val) &&
                typeof setting.setting_val === typeof slSetting.setting_val
            ) {
                setting.setting_val = slSetting.setting_val;
            }
        }
    }
    return settings;
}
export function groupSettings(index, defaultGroups) {
    const groups = [...defaultGroups];
    const len = groups.length;
    let group, settings, kLen, ki, s;
    for (var i = 0; i < len; i++) {
        group = groups[i];
        settings = [];
        kLen = group.keys.length;
        for (ki = 0; ki < kLen; ki++) {
            s = index[group.keys[ki]];
            if (s) {
                settings.push(s);
            }
        }
        group.settings = settings;
    }
    return groups;
}

export function convertSwitchFieldValue(settings) {
    return settings.map(group => {
        group.settings.forEach(setting => {
            if (setting.field_type === 'switch') {
                setting.setting_val = Boolean(Number(setting.setting_val));
            }
            return setting;
        });
        return group;
    });
}
